module.exports = __webpack_public_path__ + "static/media/hand.cb54f173.png";